var EmissionInclude = {
    scope: true,
    factor: {
        include: {
            unit: true,
            territory: true,
            modeledImpact: true,
            origin: true,
            activityDataSource: {
                include: {
                    activityDataSourceTypes: true,
                    parent: {
                        include: {
                            parent: true,
                        },
                    },
                },
            },
            children: {
                include: {
                    unit: true,
                    activityDataSource: true,
                },
            },
        },
    },
};
export var OrganizationEmissionInclude = Object.assign({}, EmissionInclude);
export var ProductEmissionInclude = Object.assign({}, EmissionInclude);
var EmissionSelect = {
    outOfScope: false,
    version: false,
    deletedAt: false,
    deleted: false,
    id: true,
    createdAt: true,
    updatedAt: true,
    scope: true,
    subcategory: {
        select: {
            id: true,
            name: true,
        },
    },
    category: {
        select: {
            id: true,
            name: true,
        },
    },
    factor: true,
    organization: {
        select: {
            id: true,
            name: true,
        },
    },
    businessUnit: {
        select: {
            id: true,
            title: true,
            metadata: true,
        },
    },
    tags: true,
    value: true,
};
export var OrganizationEmissionSelect = Object.assign({
    location: {
        select: {
            id: true,
            name: true,
            metadata: true,
        },
    },
    timestamp: true,
    logId: true,
    logEntryId: true,
}, EmissionSelect);
export var ProductEmissionSelect = Object.assign({
    product: {
        select: {
            id: true,
            name: true,
            metadata: true,
        },
    },
}, EmissionSelect);
//# sourceMappingURL=Emission.js.map